import { create } from "zustand";
import { MessagingInviteState, MessagingInviteAction } from "./types";
import { MessagingOfferNotification } from "@/common/models/messagingNotification";

export const useMessagingInviteSessionStore = create<
	MessagingInviteState & MessagingInviteAction
>((set) => ({
	messagingSession: null,
	update: (session: MessagingOfferNotification | null) =>
		set({ messagingSession: session }),
}));
